import Idle from 'react-idle';

// TODO: (CL) (MW) review Leo's comment and resolve:
// Fix error library not removeEventListener correctly

class PearIdle extends Idle {
  /* istanbul ignore next */
  removeEvents = () => {
    this.props.events.forEach((event: string) => {
      window.removeEventListener(event, this.handleEvent, true);
    });
  };
}

export default PearIdle;
